/* TNS-3523 (02.11.2026): Sylora-Warenkorb – Cross-Sell ohne Neuladen + Mengen-Animation. Global geladen (cart-drawer.liquid), weil der Schieber per innerHTML neu gerendert wird und Skripte darin nicht laufen. */
(function () {
  if (window.__syx) return; window.__syx = 1;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-syx-add]'); if (!b || b.disabled) return;
    b.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var drawer = b.closest('cart-drawer');
    var body = { items: [{ id: +b.getAttribute('data-syx-add'), quantity: 1 }] };
    if (drawer && drawer.renderContents) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json(); })
      .then(function (j) {
        b.classList.add('is-ok');
        setTimeout(function () {
          if (j && j.sections && j.sections['cart-drawer'] && drawer && drawer.renderContents) {
            try { j.id = j.id || (j.items && j.items[0] && j.items[0].variant_id); drawer.renderContents(j); return; } catch (err) {}
          }
          location.reload();
        }, 550);
      })
      .catch(function () { b.disabled = false; });
  });
})();

(function(){
  if (window.__syq) return; window.__syq = 1;
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('.tns-wk__menge-knopf'); if (!k) return;
    var f = k.parentNode && k.parentNode.querySelector('.tns-wk__menge-feld'); if (!f) return;
    f.classList.remove('sy-bump'); void f.offsetWidth; f.classList.add('sy-bump');
  }, true);
})();
